// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button-module__Button__1ItqE","Success":"Button-module__Success__1l2_U","Danger":"Button-module__Danger__2168-"};